import { render, staticRenderFns } from "./GlyanecBusinessCard.vue?vue&type=template&id=80088b70&scoped=true&"
import script from "./GlyanecBusinessCard.vue?vue&type=script&lang=js&"
export * from "./GlyanecBusinessCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80088b70",
  null
  
)

export default component.exports